<div class="pickup-for-current-location">
    <div class="pickup-for-current-location__inner">
        <shared-pickup-button [size]="size" mode="current-location" (onDropdownToggle)="dropdownToggle($event)"
                              (onDropdownSelected)="dropdownSelected($event)"
                              [optionsAmount]="(currentLocationPickupTimesList$ | async)?.length"
                              [options]="currentLocationPickupTimesListFiltered$ | async" [label]="currentLocationPickupTimeLabel$ | async"
                              [selected]="currentLocationPickupTimeSelected$ | async" dropdownWidth="full">
        </shared-pickup-button>
    </div>
</div>
